export const ROUTES = {
  ROOT: '/',
  TASKS: '/tasks',
  PROFILE: '/profile',
  LEARNERS: '/learners',
  CREATE_PASSWORD: '/auth/create-pass/:token',
  RESET_PASSWORD: '/auth/reset-pass/:token'
}
